import { useMemo } from 'react';
import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';
import { mapInvoiceDtoToEntity } from '@entities/invoice';
import type { InvoiceDto, PaginatedResponse } from '@shared/api/contracts';

const DEFAULT_LIMIT = 10;

export const useInvoicesList = (page = 1, limit = DEFAULT_LIMIT) => {
  const { data, error, isLoading, mutate } = useSWR<PaginatedResponse<InvoiceDto>>(
    swrKeys.invoices.all({ page, limit })
  );

  const invoices = useMemo(
    () => (data?.data ?? []).map(mapInvoiceDtoToEntity),
    [data?.data]
  );

  return {
    invoices,
    pagination: data?.pagination ?? { page, limit, total: 0 },
    isLoading,
    error,
    mutate,
  };
};
